<ng-container *ngIf="!loading && !noDevice">
    <ion-fab *ngIf="plt.sizeSm && !settingsEnabled"
             vertical="top"
             horizontal="start"
             slot="fixed">

        <ion-fab-button (click)="toggleSettings()"
                        [disabled]="videoInputLoading"
                        [color]="settingsEnabled ? 'secondary' : 'medium'">
            <svg-icon src="/assets/icons/ico-settings.svg"
                      [applyClass]="true"
                      class="setting">
            </svg-icon>
        </ion-fab-button>

    </ion-fab>

    <ion-fab *ngIf="!settingsEnabled && !plt.sizeMd"
             vertical="top"
             horizontal="end"
             slot="fixed">

        <ion-fab-button *ngIf="!noScreenShare"
                        (click)="toggleContentShare()"
                        [title]="'VIDEOCALL_SCREEN_SHARE' | translate"
                        [color]="contentShared ? 'secondary' : 'medium'">
            <svg-icon src="/assets/icons/screen-share.svg"
                      [applyClass]="true"
                      class="setting">
            </svg-icon>
        </ion-fab-button>

    </ion-fab>

    <ion-fab *ngIf="!(settingsEnabled && plt.sizeSm)"
             class="control"
             [ngClass]="{'screen-share': sharedVideo && !plt.sizeSm}"
             vertical="bottom"
             horizontal="center"
             slot="fixed">
        <ion-fab-button (click)="toggleMicrophone()"
                        [title]="'VIDEOCALL_TOGGLE_MIRCOPHONE' | translate"
                        [color]="!muted ? 'secondary' : 'medium'">
            <ion-icon *ngIf="!audioInputLoading && !muted"
                      name="mic-outline">
            </ion-icon>
            <ion-icon *ngIf="!audioInputLoading && muted"
                      name="mic-off-outline">
            </ion-icon>
            <ion-spinner *ngIf="audioInputLoading"
                         name="dots">
            </ion-spinner>
        </ion-fab-button>
        <ion-fab-button *ngIf="videoInputDevices.length > 0 && !noCamera"
                        (click)="toggleVideo()"
                        [disabled]="videoInputLoading"
                        [title]="'VIDEOCALL_TOGGLE_CAMERA' | translate"
                        [color]="videoEnabled ? 'secondary' : 'medium'">
            <ion-icon *ngIf="!videoInputLoading && !videoEnabled"
                      name="videocam-off-outline">
            </ion-icon>
            <ion-icon *ngIf="!videoInputLoading && videoEnabled"
                      name="videocam-outline">
            </ion-icon>
            <ion-spinner *ngIf="videoInputLoading"
                         name="dots">
            </ion-spinner>
        </ion-fab-button>
        <ion-fab-button (click)="toggleAudio()"
                        [title]="'VIDEOCALL_TOGGLE_SPEAKERS' | translate"
                        [color]="audioEnabled ? 'secondary' : 'medium'">
            <ion-icon *ngIf="!audioOutputLoading && audioEnabled"
                      name="volume-high-outline">
            </ion-icon>
            <ion-icon *ngIf="!audioOutputLoading && !audioEnabled"
                      name="volume-mute-outline">
            </ion-icon>
            <ion-spinner *ngIf="audioOutputLoading"
                         name="dots">
            </ion-spinner>
        </ion-fab-button>

        <ion-fab-button *ngIf="!plt.sizeSm"
                        (click)="toggleSettings()"
                        [color]="settingsEnabled ? 'secondary' : 'medium'">
            <svg-icon src="/assets/icons/ico-settings.svg"
                      [applyClass]="true">
            </svg-icon>
        </ion-fab-button>


        <ion-fab-button (click)="endCall()"
                        [color]="'danger'"
                        class="add-newsfeed-button">
            <ion-icon name="exit-outline">
            </ion-icon>
        </ion-fab-button>

    </ion-fab>

    <div [ngClass]="{'setting-box': settingsEnabled, 'top-menu': plt.tabMenuOnTop}">

        <ion-grid class="ion-no-padding">

            <ion-row>
                <ion-col *ngIf="settingsEnabled"
                         col-sm="12"
                         col-md="8">
                    <ion-item>
                        <ion-label *ngIf="plt.sizeMs"
                                   position="stacked">
                            {{ 'VIDEOCALL_CAMERA' | translate }}
                        </ion-label>
                        <ion-label *ngIf="!plt.sizeMs"
                                   position="fixed">
                            {{ 'VIDEOCALL_CAMERA' | translate }}
                        </ion-label>
                        <ion-select [interface]="selectType"
                                    [cancelText]="'BUTTON_CANCEL' |  translate"
                                    name="camera"
                                    #camera="ngModel"
                                    [ngModel]="videoInput"
                                    (ionChange)="selectCamera($event)">
                            <ng-container *ngIf="!submit">
                                <ion-select-option *ngFor="let device of videoInputDevices; let i = index"
                                                   [value]="device">
                                    <ng-container *ngIf="device.label">{{ device.label }}</ng-container>
                                    <ng-container *ngIf="!device.label">default {{ i + 1 }}</ng-container>
                                </ion-select-option>
                            </ng-container>
                        </ion-select>
                    </ion-item>
                </ion-col>
                <ion-col col-sm="12"
                         col-md="4">
                    <div [ngClass]="{'enabled': videoEnabled, 'big': !settingsEnabled, 'screen-share': sharedVideo && !plt.sizeSm}"
                         class="video-preview-box">
                        <div *ngIf="!settingsEnabled"
                             class="centered participant"
                             [ngClass]="{'top-menu': plt.tabMenuOnTop, 'camera-on': (settingsEnabled || videoEnabled)}">
                            <img *ngIf="!(settingsEnabled || videoEnabled)"
                                 img-avatar
                                 class="attendee-picture"
                                 [src]="plt.createSignedLink(user.selected_participant.picture_url)"
                                 width="50"
                                 alt="{{user.selected_participant.firstname}} {{user.selected_participant.lastname}}">
                            <h2>{{user.selected_participant.firstname}} {{user.selected_participant.lastname}}</h2>
                        </div>
                        <video *ngIf="!noCamera"
                               [ngClass]="{'hidden': noDevice || (!videoEnabled && !settingsEnabled)}"
                               id="video-preview">
                        </video>
                        <ion-icon *ngIf="muted && !settingsEnabled"
                                  [applyClass]="true"
                                  name="mic-off-outline">
                        </ion-icon>
                    </div>
                </ion-col>
            </ion-row>

            <ng-container *ngIf="settingsEnabled">

                <ion-row>
                    <ion-col col-sm="12"
                             col-md="8">
                        <ion-item>
                            <ion-label *ngIf="plt.sizeMs"
                                       position="stacked">
                                {{ 'VIDEOCALL_MIRCOPHONE' | translate }}
                            </ion-label>
                            <ion-label *ngIf="!plt.sizeMs"
                                       position="fixed">
                                {{ 'VIDEOCALL_MIRCOPHONE' | translate }}
                            </ion-label>
                            <ion-select [interface]="selectType"
                                        [cancelText]="'BUTTON_CANCEL' |  translate"
                                        name="microphone"
                                        #microphone="ngModel"
                                        [ngModel]="audioInput"
                                        (ionChange)="selectMicrophone($event)">
                                <ng-container *ngIf="!submit">
                                    <ion-select-option *ngFor="let device of audioInputDevices; let i = index"
                                                       [value]="device">
                                        <ng-container *ngIf="device.label">{{ device.label }}</ng-container>
                                        <ng-container *ngIf="!device.label">default {{ i }}</ng-container>
                                    </ion-select-option>
                                </ng-container>
                            </ion-select>
                        </ion-item>
                    </ion-col>
                    <ion-col col-sm="12"
                             col-md="4">
                        <div class="progress">
                            <div id="audio-preview"
                                 class="progress-bar bg-success"
                                 role="progressbar"
                                 aria-valuenow="0"
                                 aria-valuemin="0"
                                 aria-valuemax="100">
                            </div>
                        </div>
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col col-sm="12"
                             col-md="8">
                        <ion-item>
                            <ion-label *ngIf="plt.sizeMs"
                                       position="stacked">
                                {{ 'VIDEOCALL_SPEAKERS' | translate }}
                            </ion-label>
                            <ion-label *ngIf="!plt.sizeMs"
                                       position="fixed">
                                {{ 'VIDEOCALL_SPEAKERS' | translate }}
                            </ion-label>
                            <ion-select *ngIf="audioOutputDevices.length > 0"
                                        [interface]="selectType"
                                        [cancelText]="'BUTTON_CANCEL' |  translate"
                                        name="speakers"
                                        #speakers="ngModel"
                                        [ngModel]="audioOutput"
                                        (ionChange)="selectSpeakers($event)">
                                <ng-container *ngIf="!submit">
                                    <ion-select-option *ngFor="let device of audioOutputDevices; let i = index"
                                                       [value]="device">
                                        <ng-container *ngIf="device.label">{{ device.label }}</ng-container>
                                        <ng-container *ngIf="!device.label">default {{ i + 1 }}</ng-container>
                                    </ion-select-option>
                                </ng-container>
                            </ion-select>
                            <ion-select *ngIf="audioOutputDevices.length == 0"
                                        name="speakers"
                                        disabled="true"
                                        [placeholder]="'VIDEOCALL_SPEAKERS_NOT_AVAILABLE' | translate">
                            </ion-select>
                        </ion-item>
                    </ion-col>
                    <ion-col *ngIf="!plt.is('ios')"
                             col-sm="12"
                             col-md="4">
                        <ion-button color="light"
                                    (click)="testSound()">
                            <ion-icon *ngIf="!testingSound"
                                      name="volume-high-outline">
                            </ion-icon>
                            <ion-spinner *ngIf="testingSound"
                                         name="dots">
                            </ion-spinner>
                        </ion-button>
                    </ion-col>
                </ion-row>
            </ng-container>

        </ion-grid>

        <ion-button *ngIf="settingsEnabled"
                    (click)="toggleSettings()"
                    class="submit">
            {{ 'VIDEOCALL_SAVE_SETTING' | translate }}
        </ion-button>

    </div>
</ng-container>

<div *ngIf="noDevice"
     class="centered error">
    <h4>{{'VIDEOCALL_NO_DEVICE' | translate}}</h4>
    <p [innerHTML]="'VIDEOCALL_NO_DEVICE_HINT' | translate"></p>
    <ion-row>
        <ion-col>
            <ion-button (click)=endCall()
                        color="medium">
                {{'BUTTON_CANCEL' | translate}}
            </ion-button>
        </ion-col>
        <ion-col>
            <ion-button (click)="retry()"
                        color="light">
                {{'VIDEOCALL_NO_DEVICE_RETRY' | translate}}
            </ion-button>
        </ion-col>
    </ion-row>
</div>

<div *ngIf="loading"
     class="centered"
     [ngClass]="{'top-menu': plt.tabMenuOnTop}">
    <ion-spinner color="light"></ion-spinner>
</div>

<div *ngIf="!meetingStartSucceeded"
     class="centered"
     [ngClass]="{'top-menu': plt.tabMenuOnTop}">
    <h2>{{'VIDEOCALL_WAITING_FOR_START' | translate}}</h2>
    <ion-spinner color="light"></ion-spinner>
</div>

<div class="attendee-boxes"
     [ngClass]="{'hidden': settingsEnabled, 'screen-share': sharedVideo && !plt.sizeSm}">
    <div *ngIf="!loading && meetingStartSucceeded"
         class="box fake">
    </div>
    <ng-container *ngFor="let attendee of attendeePresenceSet">
        <div class="box"
             [ngClass]="{'active': activeSpeaker == attendee && !sharedVideo, 'hidden': (!roster[attendee] || !roster[attendee].visible) || ((activeSpeaker !== attendee || sharedVideo) && plt.sizeSm)}">
            <div *ngIf="roster[attendee] && !videoStreams[attendee]"
                 class="centered participant"
                 [ngClass]="{'top-menu': plt.tabMenuOnTop}">
                <img img-avatar
                     class="attendee-picture"
                     [src]="plt.createSignedLink(roster[attendee].attendee.picture_url)"
                     [width]="activeSpeaker == attendee  && !sharedVideo ? 300 : 50"
                     alt="{{roster[attendee].attendee.firstname}} {{roster[attendee].attendee.lastname}}">
                <h2>{{roster[attendee].attendee.firstname}} {{roster[attendee].attendee.lastname}}</h2>
            </div>
            <div *ngIf="roster[attendee] && videoStreams[attendee]"
                 [ngClass]="{'camera-on': videoStreams[attendee], 'centered active' : activeSpeaker != attendee, 'active-participant': activeSpeaker == attendee, 'top-menu': plt.tabMenuOnTop}">
                <h2>{{roster[attendee].attendee.firstname}} {{roster[attendee].attendee.lastname}}</h2>
            </div>
            <video class="video-meeting"
                   [id]="attendee"
                   [ngClass]="{'hidden': !videoStreams[attendee]}">
            </video>
            <ion-icon *ngIf="roster[attendee] && roster[attendee].muted"
                      [applyClass]="true"
                      name="mic-off-outline">
            </ion-icon>
        </div>
    </ng-container>

    <div *ngIf="attendeePresenceSet.size > streamLimits && !plt.sizeSm"
         class="attendee-count"
         (click)="publishOpenAttendees()">
        + {{ attendeePresenceSet.size - (streamLimits)}} {{ 'ATTENDEE_LIST_NUMBER_OF_ATTENDEES' | translate }}
    </div>
    <div *ngIf="plt.sizeSm"
         class="attendee-count"
         (click)="publishOpenAttendees()">
        {{ attendeePresenceSet.size + 1}} {{ 'ATTENDEE_LIST_NUMBER_OF_ATTENDEES' | translate }}
    </div>
</div>
<div [ngClass]="{'hidden': !sharedVideo || !meetingStartSucceeded || settingsEnabled, 'top-menu': plt.tabMenuOnTop, 'screen-share': sharedVideo && !plt.sizeSm}"
     class="video-box">
    <video id="video-meeting-sharing">
    </video>
</div>
<audio id="meeting-audio"
       style="visibility:hidden;max-height:0;">
</audio>